import styles from "./UpgradeCard.module.scss";
import arrowIcon from "../../../icons/arrow.png";
import currencyIcon from "./icons/currency.png";
import { FC } from "react";
import { IWorkProp } from "../../../redux/work/get-work.handler";
import { formatNumberWithSpaces } from "../../../utils/numbers";
import { Highlightable } from "../../../components/Highlight/Highlightable";
import { ActionPromptType } from "../../../hooks/prompts";

interface IUpgradeCardProps {
    description: string;
    iconType: string;
    workProp: IWorkProp;
    unitName: string;
    handler: () => void;
}

export const UpgradeCard: FC<IUpgradeCardProps> = ({ description, iconType, workProp, unitName, handler }) => {
    const getValue = () => workProp.value % 1 === 0 ? workProp.value : workProp.value.toFixed(2);

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <img src={iconType} alt="Energy Icon" className={styles.icon} />

                <h3 className={styles.title}>
                    { description } <span className={styles.energyValue}>{`${getValue()} ${unitName}`}</span>
                </h3>
            </div>

            <div className={styles.progressSection}>
                <div className={styles.progressHeader}>
                
                    <span className={styles.progressLabel}>
                        Прогресс{" "}
                        <img
                            src={arrowIcon}
                            alt="Arrow Icon"
                            className={styles.arrowIcon}
                        />
                    </span>

                    <span className={styles.progressValue}>{workProp.level}/{workProp.maxLevel}</span>
                </div>
            
                <div className={styles.progressBar}>
                    <div className={styles.progressFill} style={{ width: `${100 * workProp.level / workProp.maxLevel}%` }}></div>
                </div>
            </div>

            {workProp.level < workProp.maxLevel && (
                <Highlightable
                    promptType={ActionPromptType.UPGRADE_WORK_FIRST_TIME}
                    highlightClass={styles.highlight}
                >
                    <button
                        className={styles.completedButton}
                        onClick={handler}
                    >
                        Улучшить
                        <span className={styles.currencyBlock}>
                            <img
                                src={currencyIcon}
                                alt="Currency Icon"
                                className={styles.currencyIcon}
                            />
                            {formatNumberWithSpaces(workProp.cost)}
                        </span>
                    </button>
                </Highlightable>
            )}
        </div>
    );
};
